import React from "react";
import Link from "next/link";
import Image from "next/image";
import Remote from "../LoaderRemote";
import styles from "./AllVillasCta.module.css";
import { useTranslation } from "../../context/TranslationContext";

// Tarih seçmeden tüm villalara göz atmak isteyenler için.
// variant="strip": masaüstünde arama kutusunun altına yapışık şerit
// variant="card": mobil / tablet için tek başına kart
const AllVillasCta = ({ destinations = [], variant = "card", className = "" }) => {
  const {
    allVillasCta,
    allVillasCtaStrip,
    allVillasCtaRest,
    allVillasCtaSub,
  } = useTranslation();
  const isStrip = variant === "strip";
  const photos = destinations.filter((d) => d?.resim).slice(0, 3);
  const names = destinations
    .slice(0, 3)
    .map((d) => d.baslik)
    .join(", ");
  const subText = names ? names + " " + allVillasCtaRest : allVillasCtaSub;

  const stack =
    photos.length === 3 ? (
      <span
        className={styles.Stack + (isStrip ? " " + styles.StackSm : "")}
        aria-hidden="true"
      >
        {photos.map((d) => (
          <span key={d.id} className={styles.Photo}>
            <Image
              src={d.resim}
              loader={Remote}
              width={isStrip ? 44 : 56}
              height={isStrip ? 44 : 56}
              objectFit="cover"
              alt=""
            />
          </span>
        ))}
      </span>
    ) : null;

  const arrow = (
    <span
      className={
        "relative flex items-center justify-center text-white rounded-full shrink-0 bg-brand-color-secondary " +
        (isStrip ? "w-10 h-10 " : "w-11 h-11 ") +
        styles.Go
      }
      aria-hidden="true"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-5 h-5"
      >
        <path d="M5 12h14" />
        <path d="m13 6 6 6-6 6" />
      </svg>
    </span>
  );

  if (isStrip)
    return (
      <Link href="/kiralik-villalar">
        <a
          title={allVillasCta}
          className={
            "group relative items-center gap-4 py-2.5 pl-4 pr-5 border-t border-[#d9eef0] bg-[#effafa] hover:bg-[#e2f6f6] shadow-search transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary " +
            styles.Card +
            " " +
            className
          }
        >
          {stack}
          <span className="flex flex-col min-w-0 mr-auto">
            <span className="text-15 font-bold leading-tight text-brand-black">
              {allVillasCtaStrip}
            </span>
            <span className="mt-0.5 text-xs font-medium text-brand-black opacity-60">
              {subText}
            </span>
          </span>
          <span className="text-sm font-bold text-brand-color-secondary whitespace-nowrap">
            {allVillasCta}
          </span>
          {arrow}
        </a>
      </Link>
    );

  return (
    <Link href="/kiralik-villalar">
      <a
        title={allVillasCta}
        className={
          "group flex items-center gap-4 py-3 pl-3 pr-4 bg-white rounded-lg shadow-lg ring-1 ring-black/5 transition-shadow hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-primary " +
          styles.Card +
          " " +
          className
        }
      >
        {stack}
        <span className="flex flex-col min-w-0 mr-auto">
          <span className="text-base font-bold leading-tight text-brand-black">
            {allVillasCta}
          </span>
          <span className="mt-0.5 text-xs font-medium leading-snug text-brand-black opacity-60">
            {subText}
          </span>
        </span>
        {arrow}
      </a>
    </Link>
  );
};

export default AllVillasCta;
